/* eslint-disable */
import girl1 from '../assets/svg/testimonials/girl1.svg'
import girl2 from '../assets/svg/testimonials/girl2.svg'
import girl3 from '../assets/svg/testimonials/girl3.svg'
import boy1 from '../assets/svg/testimonials/boy1.svg'
import boy2 from '../assets/svg/testimonials/boy2.svg'
import boy3 from '../assets/svg/testimonials/boy3.svg'



export const testimonialsData = [
    {
        id: 1,
        name: 'Himanshu Ahuja',
        title: 'ahujaproducts.netlify.app',
        text: "Siddharth Bisht's coding skills are exceptional! His attention to detail and ability to solve complex problems is truly impressive. He delivered outstanding results on our project and I highly recommend him as a developer.",
        image: boy2
    },
    {
        id: 2,
        name: 'Vishaka Aggrawal',
        title: 'godrej146noida.com',
        text: "Siddharth Bisht's technical proficiency and innovative thinking have greatly impressed our team. He consistently delivered high-quality code and exceeded our expectations. His commitment to excellence is truly commendable. I wouldn't hesitate to recommend him to anyone seeking a skilled developer",
        image: girl2
    },
    {
        id: 3,
        name: 'Mohd Kaif',
        title: 'After School Classes Nainital',
        text: "Siddharth Bisht is an outstanding freelancer. His technical expertise, reliability, and ability to work independently make him a trusted partner. He consistently goes above and beyond to ensure project success. I highly recommend Siddharth for freelancing opportunities",
        image: boy1
    },
    // {
    //     id: 4,
    //     name: 'Joey Tribbiani',
    //     title: 'Actor',
    //     text: "Making my portfolio with this helped me get my role as 'Dr. Drake Ramoray' in 'Days Of Our Lives'. You guys are the best !",
    //     image: boy1
    // },
    // {
    //     id: 5,
    //     name: 'Rachel Green',
    //     title: 'Sales Executive',
    //     text: 'Ralph Lauren was one of the best things that ever happened to me. My portfolio made that dream happen. I owe you guys.',
    //     image: girl3
    // },
    // {
    //     id: 6,
    //     name: 'Ross Geller',
    //     title: 'Paleontologist',
    //     text: "Be it 'Rocks' or 'Bones', you need a website to display it. This is it. Great work guys !",
    //     image: boy3
    // }
]

